import { ApiConfig } from '../../../config'

/**
 * 1. 获取移动端授权 Code
 * (对应流程步骤 ②③)
 */
export async function fetchMobileAuthCode(apiConfig: ApiConfig): Promise<{ status: number; data: any } | null> {
  try {
    const url = `${apiConfig.authApiBase}/oauth2/authorize?client_id=BRohbvuMdMKgIKnivtDH&response_type=code`
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    const data = await response.json()
    return {
      status: response.status,
      data,
    }
  } catch (error) {
    console.error('[OraySDK] fetchMobileAuthCode error:', error)
    return null
  }
}

/**
 * 2. 通过授权 Code 换取 Token
 * (对应流程步骤 ⑪⑫)
 */
export async function exchangeMobileToken(apiConfig: ApiConfig, code: string): Promise<{ status: number; data: any } | null> {
  try {
    const url = `${apiConfig.authApiBase}/oauth2/authorize`
    const body = {
      type: 'authorization_code',
      authorization_code: {
        provider: 'oray',
        code,
      },
      is_set_session: true,
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })

    const data = await response.json()
    return {
      status: response.status,
      data,
    }
  } catch (error) {
    console.error('[OraySDK] exchangeMobileToken error:', error)
    return null
  }
}
